import { PageHeader } from "@/components/site/PageHeader";
import { Seo } from "@/components/site/Seo";
import { Aziende } from "@/components/site/Aziende";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Contact } from "@/components/site/Contact";

export default function AziendePage() {
  const scrollToForm = () =>
    document.querySelector("#contatti")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="aziende-page">
      <Seo
        title="Formazione Sicurezza per Aziende (D.lgs 81/08) | treffe Frosinone"
        description="Corsi di sicurezza sul lavoro e primo soccorso aziendale in sede a Frosinone o presso la tua azienda in tutta Italia. Percorsi su misura, attestati a norma di legge."
        path="/aziende"
      />
      <PageHeader
        eyebrow="Per la tua azienda"
        title={<>Sicurezza sul lavoro, senza pensieri</>}
        subtitle="Gestiamo gli adempimenti in materia di salute e sicurezza sul lavoro secondo il D.Lgs. 81/08, dalla consulenza alla formazione, con soluzioni pensate per le esigenze della tua azienda, in sede a Frosinone o direttamente nella tua azienda in tutta Italia."
      />
      <Aziende onRequestQuote={scrollToForm} />
      <HowItWorks variant="aziende" />
      <Contact preselectCourse="Consulenza aziendale D.Lgs. 81/08" showMap={false} />
    </div>
  );
}
